import React from 'react'
import { Link, Outlet } from 'react-router-dom'

import { Card, Layout, Image } from 'antd'

import ImgBg from '../../assets/images/bg.jpg'
import Logo from '../../assets/images/logo.jpg'

import './AuthLayout.less'

const AuthLayout = () => {
  return (
    <Layout style={{ backgroundImage: `url(${ImgBg})` }} className="AuthLayout">
      {/* <Layout.Header>
        <Typography.Title style={{color: 'white'}}>Craft Foods</Typography.Title>
      </Layout.Header> */}
      <Layout.Content>
        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
          <Card style={{ padding: 4, borderRadius: '10px', backgroundColor: 'white' }}>
            <Link to="/login">
              <Image src={`${Logo}`} className="logo" preview={false}></Image>
            </Link>
            <Outlet />
          </Card>
        </div>
      </Layout.Content>
    </Layout>
  )
}

export default AuthLayout
